import Config from "Config";
import { Constant } from "../Constant";
import { send } from "../SendRequest";
import {
    fullJsonObjToFieldValue,
    getIsExceedingDeadlineForm,
    getIsWithinDeadlineFormTemp,
    isCLO,
    isEmpty,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
    parseReferenceNumber,
    resetForm101TempData,
} from "../Utils";
import { Response } from "../constant/Response";
import i18n from "../i18n";

export function submitFormDone(formId, formResponse) {
    return {
        type: Constant.action.SUBMIT_FORM.DONE,
        payload: { formId, ...formResponse },
    };
}

export function submitForm(formId, formData) {
    const option = {
        url: `${Config.BASE_URL}${Constant.url.CYCHonoursSchemePrincipleForm}`,
        method: "POST",
        body: JSON.stringify(formData),
    };
    return function (dispatch) {
        return dispatch(send("SUBMIT_FORM", option))
            .then((response) => response.json())
            .then((jsonResponse) =>
                dispatch(submitFormDone(formId, jsonResponse))
            );
    };
}

export function initialForm(formId) {
    return (dispatch, getState) => {
        if (isEmpty(getState().form.referenceId)) {
            dispatch(getParameterRequest(formId)).then((latestParameter) => {
                const state = getState();
                const scrn =
                    state.profile?.selectedSCRN || state.selectedUserOrg?.scrn;
                const formStatus = state.form?.status;

                const token = state.token;
                const role = state.profile?.role;
                if (
                    formStatus == -1 &&
                    isNotEmpty(formId) &&
                    isNotEmpty(token) &&
                    isNotEmpty(role) &&
                    (isCLO(role) ? isNotEmpty(scrn) : true) &&
                    getIsWithinDeadlineFormTemp(formId, latestParameter)
                ) {
                    dispatch(updateIsExceedingDeadline(false));
                    if(formId !== "Form107"){
                    dispatch(getFormTempRequest(formId, scrn, i18n));
                    }
                   
                }
            });
        }
        dispatch({
            type: Constant.action.INITIAL_FORM,
            payload: formId,
        });
    };
}

export function clearForm() {
    return { type: Constant.action.CLEAR_FORM };
}

export function setCurrentStep(currentStep) {
    return {
        type: Constant.action.SET_CURRENT_STEP,
        payload: currentStep,
    };
}

export function setCurrentStepWithRerender(currentStep) {
    //this function is used to rerender the step in order to set default value of input when importing saved form data
    return (dispatch) => {
        dispatch(setCurrentStep(""));
        setTimeout(() => {
            dispatch(setCurrentStep(currentStep));
        }, 100);
    };
}

export function setInitialStep(initialStep) {
    return {
        type: Constant.action.SET_INITIAL_STEP,
        payload: initialStep,
    };
}

export function setMode(mode) {
    return {
        type: Constant.action.SET_MODE,
        payload: mode,
    };
}

export function setFieldValues(stepName, stepValues) {
    return {
        type: Constant.action.SET_FIELD_VALUES,
        payload: { stepName, stepValues },
    };
}

export function setFullFieldValues(fieldValues) {
    return {
        type: Constant.action.SET_FULL_FIELD_VALUS,
        payload: fieldValues,
    };
}

export function updateMobileNavStatus(isMobileNavOpen) {
    return {
        type: Constant.action.TOGGLE_MOBILE_NAV,
        payload: isMobileNavOpen,
    };
}

export function updateMultiSubmitEditing(isMultiSubmitEditing) {
    return {
        type: Constant.action.TOGGLE_MULTISUBMIT_EDITING,
        payload: isMultiSubmitEditing,
    };
}

export function updateIsExceedingDeadline(isExceedingDeadline) {
    return {
        type: Constant.action.TOGGLE_ISEXCEEDING_DEADLINE,
        payload: isExceedingDeadline,
    };
}

export function setRedirectTo(redirectUrl) {
    return {
        type: Constant.action.SET_REDIRECT_TO,
        payload: redirectUrl,
    };
}

export function resetRedirectTo() {
    return {
        type: Constant.action.RESET_REDIRECT_TO,
    };
}

export function setProfile(profile) {
    return {
        type: Constant.action.GET_USER_PROFILE.DONE,
        payload: profile,
    };
}

export function setUserOrg(userOrg) {
    return {
        type: Constant.action.SET_USER_ORG,
        payload: userOrg,
    };
}

export function resetUserOrg() {
    return {
        type: Constant.action.RESET_USER_ORG,
    };
}

export function setCurrUserOrg(selectedUserOrg) {
    return {
        type: Constant.action.SET_SELECTED_USER_ORG,
        payload: selectedUserOrg,
    };
}

export function setCurrWorkFlow(workflow) {
    return {
        type: Constant.action.SET_CURRENT_WORKFLOW,
        payload: workflow,
    };
}

export function setSearchData(searchData) {
    return {
        type: Constant.action.SET_SEARCH_DATA,
        payload: searchData,
    };
}

export function resetSelectedUserOrg() {
    return {
        type: Constant.action.RESET_SELECTED_USER_ORG,
    };
}

export function resetSearchData() {
    return {
        type: Constant.action.RESET_SEARCH_DATA,
    };
}

export function setUserRole(role) {
    return {
        type: Constant.action.SET_ROLE,
        payload: role,
    };
}
export function setOpenID(openId) {
    return {
        type: Constant.action.SET_OPENID,
        payload: openId,
    };
}
export function setUserEmail(email) {
    return {
        type: Constant.action.SET_EMAIL,
        payload: email,
    };
}

export function setSelectedSCRN(selectedSCRN) {
    return {
        type: Constant.action.SET_SELECTED_SCRN,
        payload: selectedSCRN,
    };
}

export function resetProfile() {
    return {
        type: Constant.action.RESET_PROFILE,
    };
}

export function initialApproval(formData) {
    return {
        type: Constant.action.INITIAL_APPROVAL,
        payload: formData,
    };
}

export function toggleLoadFormPopup() {
    return { type: Constant.action.TOGGLE_LOAD_FORM_POPUP };
}

export function toggleLoginDialog(isOpen) {
    return {
        type: Constant.action.TOGGLE_LOGIN_DIALOG,
        payload: isOpen,
    };
}

export function toggleApproverEditLoadFormPopup() {
    return { type: Constant.action.TOGGLE_APPROVER_EDIT_LOAD_FORM_POPUP };
}

export function setApplicantFormList(formList) {
    return {
        type: Constant.action.SET_APPLICANT_FORM_LIST,
        payload: formList,
    };
}

export function resetApplicantFormList() {
    return {
        type: Constant.action.RESET_APPLICANT_FORM_LIST,
    };
}

export function setStepSequence(stepSequence) {
    return {
        type: Constant.action.SET_STEP_SEQUENCE,
        payload: stepSequence,
    };
}

export function setForm101SubmitedJob(jobData) {
    return {
        type: Constant.action.SET_FORM101_SUBMITED_JOB,
        payload: jobData,
    };
}

export function setFormEnterLocalTime(formEnterLocalTime) {
    return {
        type: Constant.action.SET_FORM_ENTER_LOCALTIME,
        payload: formEnterLocalTime,
    };
}

export function getApprovalForm(referenceNumber) {
    const { formId, id } = parseReferenceNumber(referenceNumber);
    const option = {
        url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/${id}`,
    };
    return function (dispatch) {
        dispatch(send("GET_APPROVAL_FORM", option))
            .then((response) => {
                if (response.status === Response.expectedError) {
                    localStorage.removeItem("login_redirect");
                }
                return response.json();
            })
            .then((formData) => {
                if (formId == "Form041" || formId == "Form043") {
                    dispatch({
                        type: Constant.action.GET_PARAMS.DONE,
                        payload: formData.params,
                    });
                }
                dispatch(
                    initialApproval({
                        ...formData,
                        formId: formId,
                    })
                );
                if (formId === "Form101") {
                    dispatch(setForm101SubmitedJob(formData?.job));
                    dispatch(getLatestParameter(formId));
                }
                if (getIsExceedingDeadlineForm(formId)) {
                    dispatch(getLatestParameter(formId));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export function getFormTempDone(fullJsonObj) {
    return {
        type: Constant.action.GET_FORM_TEMP.DONE,
        payload: fullJsonObj,
    };
}

export function getFormTempLanguage(language) {
    return {
        type: Constant.action.GET_FORM_TEMP_LANGUAGE,
        payload: language,
    };
}

export function getFormTempRequest(formId, scrn = null, i18n) {
    const option = {
        url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}Temp`,
        method: "POST",
        body: JSON.stringify({
            scrn: scrn,
        }),
    };
    return (dispatch) => {
        dispatch(send("GET_FORM_TEMP", option))
            .then((response) => response.json())
            .then((jsonResponse) => {
                dispatch(getFormTempLanguage(jsonResponse));
                const { fullJsonObj } = jsonResponse;
                if (isNotEmpty(fullJsonObj)) {
                    const fullJsonObjData = JSON.parse(fullJsonObj);
                    if (formId === "Form101") {
                        const requestData = {
                            hkidCardNo: jsonResponse?.hkidCardNo,
                            passport: jsonResponse?.passport,
                            job: jsonResponse?.job,
                        };
                        const option = {
                            url: `${Config.CONTENT_PATH}/form101/effectiveHkIdOrPassport`,
                            method: "POST",
                            body: JSON.stringify(requestData),
                        };
                        dispatch(send("GET_EFFECTIVE_HKID", option))
                            .then((res) => res.json())
                            .then((data) => {
                                const returnStep2 =
                                    data?.isPublish === false ||
                                    data?.inDeadline === false;
                                const returnStep3 =
                                    data?.hkidCardNo === false ||
                                    data?.passport === false;
                                if (returnStep2) {
                                    fullJsonObjData.currentStep = "Post";
                                } else if (returnStep3) {
                                    if (returnStep3) {
                                        fullJsonObjData.currentStep =
                                            "PersonalParticulars";
                                    }
                                }
                                const fullJsonObjTrans =
                                    fullJsonObjToFieldValue(
                                        fullJsonObjData,
                                        jsonResponse
                                    );
                                dispatch(getFormTempDone(fullJsonObjTrans));
                                dispatch(toggleLoadFormPopup());
                            });
                    } else if (formId === "Form100") {
                        const option = {
                            url: `${
                                Config.CONTENT_PATH
                            }/${formId.toLowerCase()}/getParameters`,
                        };
                        dispatch(send("GET_PARAMS", option))
                            .then((response) => response.json())
                            .then((paramsJsonResponse) => {
                                const exerciseParameters = JSON.parse(
                                    paramsJsonResponse?.exercise
                                );
                                const checkedFullJsonObjData =
                                    resetForm101TempData(
                                        jsonResponse,
                                        fullJsonObjData,
                                        exerciseParameters,
                                        i18n
                                    );
                                const fullJsonObjTrans =
                                    fullJsonObjToFieldValue(
                                        checkedFullJsonObjData.fullJsonObjData,
                                        checkedFullJsonObjData.jsonResponse
                                    );
                                dispatch(getFormTempDone(fullJsonObjTrans));
                                dispatch(toggleLoadFormPopup());
                            });
                    } else if (formId === "Form104") {
                        const schoolNumber = jsonResponse?.schoolNumber;
                        const option = {
                            url: `${Config.CONTENT_PATH}/form104/getScmInfoBySchoolNumberAndCheckSubmit/${schoolNumber}`,
                        };
                        dispatch(send("GET", option))
                            .then((response) => response.json())
                            .then((data) => {
                                if (data?.success === true) {
                                    const fullJsonObjTrans =
                                        fullJsonObjToFieldValue(
                                            fullJsonObjData,
                                            jsonResponse
                                        );
                                    if (isNotEmpty(data?.data?.formLanguage)) {
                                        const languageObj = {
                                            Eng: "en",
                                            Cht: "tc",
                                        };
                                        fullJsonObjTrans.PartA = {
                                            ...fullJsonObjTrans?.PartA,
                                            ...{
                                                currentLanguage:
                                                    languageObj?.[
                                                        data?.data?.formLanguage
                                                    ],
                                            },
                                        };
                                    }
                                    dispatch(getFormTempDone(fullJsonObjTrans));
                                    dispatch(toggleLoadFormPopup());
                                } else {
                                    const fullJsonObjTrans =
                                        fullJsonObjToFieldValue(
                                            fullJsonObjData,
                                            jsonResponse
                                        );
                                    fullJsonObjTrans.currentStep = "PartA";
                                    dispatch(getFormTempDone(fullJsonObjTrans));
                                    dispatch(toggleLoadFormPopup());
                                }
                            });
                    } else {
                        const fullJsonObjTrans = fullJsonObjToFieldValue(
                            fullJsonObjData,
                            jsonResponse
                        );
                        dispatch(getFormTempDone(fullJsonObjTrans));
                        dispatch(toggleLoadFormPopup());
                    }
                }
            })
            .catch((err) => {
                console.log("GET_FORM_TEMP error: ", err);
            });
    };
}

export function getApproverEditFormTempDone(fullJsonObj) {
    return {
        type: Constant.action.GET_APPROVER_EDIT_FORM_TEMP.DONE,
        payload: fullJsonObj,
    };
}

export function getApproverEditFormTempLanguage(language) {
    return {
        type: Constant.action.GET_APPROVER_EDIT_FORM_LANGUAGE,
        payload: language,
    };
}

export function getApproverEditFormTempRequest(
    formId,
    formRef,
    status,
    saveType
) {
    const option = {
        url: `${
            Config.CONTENT_PATH
        }/${formId.toLowerCase()}Temp/getFormByApprover/${formRef}/${status}`,
        method: "GET",
    };
    return (dispatch) => {
        dispatch(send("GET_APPROVER_EDIT_FORM_TEMP", option))
            .then((response) => response.json())
            .then((jsonResponse) => {
                const { fullJsonObj } = jsonResponse;
                if (isNotEmpty(fullJsonObj)) {
                    const fullJsonObjTrans = fullJsonObjToFieldValue(
                        JSON.parse(fullJsonObj),
                        jsonResponse
                    );
                    if (jsonResponse?.saveType === saveType) {
                        dispatch(getApproverEditFormTempLanguage(jsonResponse));
                        dispatch(getApproverEditFormTempDone(fullJsonObjTrans));
                        dispatch(toggleApproverEditLoadFormPopup());
                    }
                }
            })
            .catch((err) => {
                console.log("GET_APPROVER_EDIT_FORM_TEMP error: ", err);
            });
    };
}

export function addAttachment(files) {
    return {
        type: Constant.action.ADD_ATTACHMENT,
        payload: files,
    };
}

export function setReplySlipOption(options) {
    return {
        type: Constant.action.SET_REPLY_SLIP_OPTION,
        payload: options,
    };
}

export function initIamsmartIasToken(iasTokenMap) {
    if (sessionStorage && sessionStorage.setItem) {
        sessionStorage.setItem("iasTokenMap", JSON.stringify(iasTokenMap));
    }
    return {
        type: Constant.action.INIT_IAMSMART_IASTOKEN_FIELD_MAP,
        payload: iasTokenMap,
    };
}

export function initIamsmartFieldMap(fieldMap) {
    return {
        type: Constant.action.INIT_IAMSMART_FIELD_MAP,
        payload: fieldMap,
    };
}

export function setIamsmartFieldMap(fieldMap) {
    return {
        type: Constant.action.SET_IAMSMART_FIELD_MAP,
        payload: fieldMap,
    };
}

export function getParameterRequest(formId) {
    const option = {
        url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/getParameters`,
    };
    return (dispatch) => {
        return dispatch(send("GET_PARAMS", option))
            .then((response) => response.json())
            .then((jsonResponse) => {
                dispatch({
                    type: Constant.action.GET_PARAMS.DONE,
                    payload: jsonResponse,
                });
                dispatch({
                    type: Constant.action.GET_LATEST_PARAMS.DONE,
                    payload: jsonResponse,
                });
                return jsonResponse;
            });
        // Promise.resolve({
        //     formid: formId,
        //     principal: "tsang Ho Ho",
        //     dueDate: "2019-11-30",
        //     schoolYear: "2008",
        //     tel: "63456789",
        //     versionCode: "11v2",
        // }).then((jsonObj) => {
        //     dispatch({
        //         type: Constant.action.GET_PARAMS_SUCCESS,
        //         payload: jsonObj,
        //     });
        // });
    };
}

export function getLatestParameter(formId) {
    const option = {
        url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/getParameters`,
    };
    return (dispatch) => {
        return dispatch(send("GET_LATEST_PARAMS", option))
            .then((response) => response.json())
            .then((jsonResponse) => {
                dispatch({
                    type: Constant.action.GET_LATEST_PARAMS.DONE,
                    payload: jsonResponse,
                });
                return jsonResponse;
            });
    };
}

export function getIamsmartProfileDone(accessToken, openID, ticketID) {
    if (sessionStorage && sessionStorage.setItem) {
        sessionStorage.setItem(
            "iamsmartProfile",
            JSON.stringify({ accessToken, openID, ticketID })
        );
    }
    return {
        type: Constant.action.GET_IAMSMART_PROFILE.DONE,
        payload: { accessToken, openID, ticketID },
    };
}

export function getIamsmartProfileAction(authCode) {
    const headers = {
        authCode: authCode,
        clientEntityName: "edbeform",
        userAgent: navigator.userAgent,
        fields: "enName",
    };
    const option = {
        url: "/iAMSmartEDB/getProfile",
        method: "POST",
        header: headers,
    };
    return function (dispatch) {
        return dispatch(send("GET_IAMSMART_PROFILE", option))
            .then((response) => response.json())
            .then((jsonObj) => {
                dispatch(
                    getIamsmartProfileDone(
                        jsonObj.accessToken,
                        jsonObj.openID,
                        jsonObj.ticketID
                    )
                );
            });
    };
}

export function updateIasField(fieldName) {
    return {
        type: Constant.action.UPDATE_IAS_FIELD,
        payload: fieldName,
    };
}

export function resetIasFormFilled() {
    return {
        type: Constant.action.RESET_FORMFILLED,
    };
}

export function resetToken() {
    if (sessionStorage && sessionStorage.setItem) {
        sessionStorage.removeItem("iamsmartProfile");
        sessionStorage.removeItem("iasTokenMap");
        sessionStorage.removeItem("interfaceUsername");
    }
    return { type: Constant.action.RESET_TOKEN };
}

export function setToken(token) {
    return {
        type: Constant.action.SET_TOKEN,
        payload: token,
    };
}

export function setParse(parseData) {
    return {
        type: Constant.action.SET_PARSE_DATA,
        payload: parseData,
    };
}

export function getIamsmartTypeDone(userType) {
    if (sessionStorage && sessionStorage.setItem) {
        sessionStorage.setItem("userType", userType);
    }
    return {
        type: Constant.action.SET_USERTYPE,
        payload: userType,
    };
}

export function setKindergartenCccName(kindergartenCccName) {
    return {
        type: Constant.action.SET_KGCCC_SCRN,
        payload: kindergartenCccName,
    };
}

export function setSchoolList(schoolList) {
    return {
        type: Constant.action.SET_SCHOOL_LIST,
        payload: schoolList,
    };
}

export function setForm101EffectiveJob(form101EffectiveJob) {
    return {
        type: Constant.action.SET_EFFECTIVE_JOB,
        payload: form101EffectiveJob,
    };
}

export function userLogin(formData, onError) {
    const option = {
        url: `${Config.CONTENT_PATH}/auth`,
        method: "POST",
        body: JSON.stringify(formData),
    };
    return function (dispatch) {
        return dispatch(send("LOGIN", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .then((jsonResponse) => {
                if (isNotEmpty(jsonResponse?.token)) {
                    dispatch(setToken(jsonResponse));
                }
                if (isNotEmpty(jsonResponse?.role)) {
                    dispatch(setUserRole(jsonResponse.role));
                }
                if (isNotEmpty(jsonResponse?.redirectUrl)) {
                    dispatch(setRedirectTo(jsonResponse.redirectUrl));
                }
                if (isObjectEmpty(jsonResponse)) {
                    onError();
                }
                return jsonResponse;
            })
            .catch((err) => {
                onError();
            });
    };
}

export function publicUserLogin(formData, onError) {
    const option = {
        url: `${Config.CONTENT_PATH}/publicLogin`,
        method: "POST",
        body: formData,
    };
    return function (dispatch) {
        return dispatch(send("PUBLIC_LOGIN", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .then((jsonResponse) => {
                if (jsonResponse?.msg === "SUCCESS") {
                    dispatch(setToken(jsonResponse));
                    dispatch(setUserRole(jsonResponse?.role));
                }
                return jsonResponse;
            })
            .catch((err) => {
                onError(err);
            });
    };
}

export function iAMSmartLinkUp(body, onError) {
    const option = {
        url: `${Config.CONTENT_PATH}/iamsmartLinkUp`,
        method: "POST",
        body: JSON.stringify(body),
    };
    return function (dispatch) {
        return dispatch(send("IAMSMART_LINK_UP", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .then((jsonResponse) => {
                if (isEmpty(jsonResponse?.msg)) {
                    dispatch(setToken(jsonResponse));
                    dispatch(setUserRole(jsonResponse?.role));
                }
                return jsonResponse;
            })
            .catch((err) => {
                onError(err);
            });
    };
}

export function getOTP(formData, onError) {
    const option = {
        url: `${Config.CONTENT_PATH}/publicLoginOneTimeEmail`,
        method: "POST",
        body: formData,
    };
    return function (dispatch) {
        return dispatch(send("PUBLIC_OTP", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .catch((err) => {
                onError();
            });
    };
}

export function getLinkUpOTP(body, onError) {
    const option = {
        url: `${Config.CONTENT_PATH}/iamsmartOTPEmail`,
        method: "POST",
        body: JSON.stringify(body),
    };
    return function (dispatch) {
        return dispatch(send("LINK_UP_OTP", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .catch((err) => {
                onError();
            });
    };
}

export function getCloParameter(scrnContent) {
    const option = {
        url: `${Config.CONTENT_PATH}/clo`,
        method: "POST",
        body: JSON.stringify({ scrn: scrnContent }),
    };
    return (dispatch) => {
        dispatch(send("GET_CLO_INFO", option))
            .then((response) => response.json())
            .then((jsonResponse) => {
                dispatch({
                    type: Constant.action.GET_CLO_INFO.DONE,
                    payload: jsonResponse,
                });
            });
    };
}

export function resetFormTitleParamList() {
    return {
        type: Constant.action.RESET_FORM_TITLE_PARAM_LIST,
    };
}

export function resetLatestParameter() {
    return {
        type: Constant.action.RESET_LATEST_PARAMETER,
    };
}

export function setFormTitleParamList(formList) {
    return {
        type: Constant.action.SET_FORM_TITLE_PARAM_LIST,
        payload: formList,
    };
}

export function getFormTitleParam() {
    const option = {
        url: `${Config.CONTENT_PATH}/parameters/formTitleParam`,
        method: "GET",
    };
    return (dispatch) => {
        dispatch(send("GET_FORM_TITLE_PARAM", option))
            .then((response) => response.json())
            .then((result) => {
                dispatch(setFormTitleParamList(result));
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };
}

export function parseToken(cookies) {
    const option = {
        url: `${Config.CONTENT_PATH}/auth/parse`,
        method: "POST",
        body: JSON.stringify(cookies),
    };
    return (dispatch) => {
        dispatch(send("PARSE_TOKEN", option))
            .then((response) => {
                switch (response?.status) {
                    case Response.ok:
                        return response.json();
                    default:
                        return Promise.reject(response);
                }
            })
            .then((result) => {
                if (isEmpty(result?.role)) {
                    dispatch({
                        type: "PARSE_TOKEN_FAIL",
                        payload: Promise.reject(result),
                    });
                }
                if (!("errorMsg" in result)) {
                    if ("token" in result) {
                        dispatch(setToken(result));
                        document.cookie = `token=${result?.token}; path=${Config.CONTENT_PATH}; max-age=3600};`;
                    } else {
                        dispatch(setToken(cookies));
                    }
                    dispatch(setUserRole(result?.role));
                    dispatch(setSelectedSCRN(result?.selectedSCRN));
                    dispatch(getUserOrg(result?.selectedSCRN));
                    if (["SA", "FO", "FR", "E"].includes(result?.role)) {
                        dispatch(getAllCollBoxGroup());
                    } else {
                        dispatch({
                            type: Constant.action.SET_ALL_COLLBOX_GROUP_AUTH,
                            payload: false,
                        });
                    }
                    // dispatch(updateProfile());
                    const storageIamsmartProfile = sessionStorage?.getItem(
                        "iamsmartProfile"
                    )
                        ? JSON.parse(sessionStorage?.getItem("iamsmartProfile"))
                        : {};
                    if (isObjectNotEmpty(storageIamsmartProfile)) {
                        dispatch(
                            getIamsmartProfileDone(
                                storageIamsmartProfile?.accessToken,
                                storageIamsmartProfile?.openID,
                                storageIamsmartProfile?.ticketID
                            )
                        );
                    }
                    if (
                        isEmpty(result?.selectedSCRN) &&
                        result?.role === "Public"
                    ) {
                        dispatch(getSelectFormList(result?.selectedSCRN));
                    }
                }
                return "user result...";
            })
            .then((result) => console.log(result))
            .catch((error) => {
                console.log("fetch error for parse: ", error);
            });
    };
}

export function getUserOrg(selectedSCRN) {
    const option = {
        url: `${Config.CONTENT_PATH}/userOrganizations/getUserOrganization`,
    };
    return (dispatch) => {
        dispatch(send("GET_USER_ORG", option))
            .then((response) => response.json())
            .then((result) => {
                const tempCurrUserOrg = result.find(
                    (item) => item.scrn === selectedSCRN
                );
                dispatch(setUserOrg(result));
                dispatch(setCurrUserOrg(tempCurrUserOrg));
                dispatch(setCurrWorkFlow(""));
                dispatch(updateProfile(selectedSCRN));
                return tempCurrUserOrg;
            })
            .then((result) => {
                console.log("running getSelectFormList");
                /* No need call getSelectFormList here, because need update list by scrn code when select school */
                //dispatch(getSelectFormList(result));
            });
    };
}

export function updateProfile(scrnContent) {
    const userData = { scrn: scrnContent };
    const option = {
        url: `${Config.CONTENT_PATH}/users/profile`,
        method: "POST",
        body: JSON.stringify(userData),
    };
    return (dispatch) => {
        dispatch(send("GET_USER_PROFILE", option))
            .then((response) => response.json())
            .then((result) => {
                dispatch(setProfile(result));
                const interfaceUsername = result?.interfaceUsername;
                console.log(
                    "interfaceUsername======********=======" + interfaceUsername
                );

                const oldInterfaceUsernameObj = sessionStorage?.getItem(
                    "interfaceUsername"
                )
                    ? JSON.parse(sessionStorage?.getItem("interfaceUsername"))
                    : {};
                const oldInterfaceUsername =
                    oldInterfaceUsernameObj?.interfaceUsername;
                console.log(
                    "oldInterfaceUsername======********=========" +
                        oldInterfaceUsername
                );
                if (interfaceUsername !== oldInterfaceUsername) {
                    if (sessionStorage && sessionStorage.setItem) {
                        sessionStorage.removeItem("iasTokenMap");
                        sessionStorage.removeItem("interfaceUsername");
                    }
                }
            });
    };
}

export function initAnon() {
    //initial the anonymous role
    return (dispatch) => {
        dispatch(resetProfile());
        dispatch(resetUserOrg());
        dispatch(resetSelectedUserOrg());
    };
}

export function updateUserRole(scrnContent) {
    const option = {
        url: `${Config.CONTENT_PATH}/users/updateAccessRole`,
        method: "POST",
        body: JSON.stringify({ scrn: scrnContent }),
    };
    return (dispatch) => {
        dispatch(send("UPDATE_ROLE", option))
            .then((response) => response.json())
            .then((result) => {
                dispatch(setUserRole(result?.role));
            });
    };
}

export function getSelectFormList(selectedUserOrg) {
    const userData = {
        scrn:
            selectedUserOrg?.scrn === undefined ? null : selectedUserOrg?.scrn,
    };

    const option = {
        url: `${Config.CONTENT_PATH}/delegation/getSelectFormList`,
        method: "POST",
        body: JSON.stringify(userData),
    };
    return (dispatch) => {
        dispatch(send("GET_APPLICANT_FORM_LIST", option))
            .then((response) => response.json())
            .then((result) => {
                // dispatch redux action
                // console.log("form list: ", result);
                dispatch(setApplicantFormList(result));
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };
}

export function updateSelectedSCRN(selectedSCRN) {
    const option = {
        url: `${Config.CONTENT_PATH}/users/updateUserOrgID/${selectedSCRN}`,
        method: "PUT",
    };
    return (dispatch) => {
        dispatch(send("UPDATE_APPLICANT_SELECTED_SCRN", option))
            // .then(() => {
            //     dispatch(setSelectedSCRN(selectedSCRN));
            // })
            .catch((error) => {
                console.log("update selectedSCRN error: ", error);
            });
    };
}

export function logout() {
    return (dispatch) => {
        dispatch(resetToken());
        dispatch(resetProfile());
        dispatch(resetApplicantFormList());
    };
}

export const stepSequenceNext = (currentStep, stepSequence) => {
    let index = 0;
    let nextStep = "";
    if (isNotEmpty(stepSequence)) {
        index = stepSequence.indexOf(currentStep);
        nextStep = stepSequence[index + 1];
    }
    return (dispatch) => {
        dispatch(setCurrentStep(nextStep));
    };
};

export const stepSequenceBack = (currentStep, stepSequence) => {
    let index = 0;
    let nextStep = "";
    if (isNotEmpty(stepSequence)) {
        index = stepSequence.indexOf(currentStep);
        nextStep = stepSequence[index - 1];
    }
    return (dispatch) => {
        dispatch(setCurrentStep(nextStep));
    };
};

export const removeFormA = (fieldValues, formStatus) => {
    let temp = fieldValues;
    if (Object.keys(temp).includes("FormA") && formStatus === 0) {
        delete temp["FormA"];
    }
    return (dispatch) => {
        dispatch(setFullFieldValues(temp));
    };
};

export function getKindergartenCccName(scrn) {
    if (isNotEmpty(scrn)) {
        const option = {
            url: `${Config.CONTENT_PATH}/clo/getKGCCC/${scrn}`,
            // url: `${Config.CONTENT_PATH}/testing/reset/ccc`,
        };
        return (dispatch) => {
            dispatch(send("GET_KGCCC_SCRN", option))
                .then((response) => response.json())
                .then(
                    (result) => {
                        dispatch(setKindergartenCccName(result));
                    },
                    (error) => {
                        console.log("error:" + error.message);
                    }
                );
        };
    }
}

export function getSchoolList() {
    const option = {
        url: `${Config.CONTENT_PATH}/clo/schoolList`,
        method: "POST",
    };
    return (dispatch) => {
        dispatch(send("GET_SCHOOLLIST", option))
            .then((response) => response.json())
            .then((data) => {
                dispatch(setSchoolList(data));
            });
    };
}

export function getForm101EffectiveJob() {
    const option = {
        url: `${Config.CONTENT_PATH}/form101/effectiveJobTitle`,
        method: "GET",
    };
    return (dispatch) => {
        dispatch(send("GET_EFFECTIVE_JOB", option))
            .then((response) => response.json())
            .then((data) => {
                dispatch(setForm101EffectiveJob(data?.result));
            });
    };
}

export function getAllCollBoxGroup() {
    const option = {
        url: `${Config.CONTENT_PATH}/collBox/getAllCollBoxGroup`,
    };
    return (dispatch) => {
        dispatch(send("GET_COLLBOX_GROUP", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true && result?.code === "0") {
                    dispatch({
                        type: Constant.action.SET_ALL_COLLBOX_GROUP_AUTH,
                        payload: true,
                    });
                } else {
                    dispatch({
                        type: Constant.action.SET_ALL_COLLBOX_GROUP_AUTH,
                        payload: false,
                    });
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };
}

export function setSsloResetPasswordTime(time) {
    return {
        type: Constant.action.SET_SSLO_RESET_PASSWORD_TIME,
        payload: time,
    };
}

export function setPublicResetPasswordTime(time) {
    return {
        type: Constant.action.SET_PUBLIC_RESET_PASSWORD_TIME,
        payload: time,
    };
}
